module.exports = __webpack_public_path__ + "static/media/kofi.cf3a8e00.png";